// App.js - Main Application Component (No Authentication)
import React, { useState } from 'react';
import { Navigation, createStyles } from './index.tsx';
import { HomePage, AboutPage, ProjectsPage, ContactPage } from './components/pages/index';

function App() {
  // State management
  const [isDarkMode, setIsDarkMode] = useState(true);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeView, setActiveView] = useState('home');

  // Create styles based on dark mode
  const styles = createStyles(isDarkMode);

  // Render active view
  const renderView = () => {
    switch (activeView) {
      case 'home':
        return <HomePage 
          isDarkMode={isDarkMode} 
          setActiveView={setActiveView}
          styles={styles}
        />;
      case 'about':
        return <AboutPage 
          isDarkMode={isDarkMode} 
          setActiveView={setActiveView} 
          styles={styles} 
        />;
      case 'projects':
        return <ProjectsPage 
          isDarkMode={isDarkMode} 
          setActiveView={setActiveView} 
          styles={styles} 
        />;
      case 'contact':
        return <ContactPage 
          isDarkMode={isDarkMode} 
          setActiveView={setActiveView} 
          styles={styles} 
        />;
      default:
        return <HomePage 
          isDarkMode={isDarkMode} 
          setActiveView={setActiveView}
          styles={styles}
        />;
    }
  };

  return (
    <div style={{
      ...styles.container,
      backgroundColor: isDarkMode ? '#000' : '#fff',
      color: isDarkMode ? '#fff' : '#000',
      transition: 'all 0.3s',
    }}>
      <Navigation 
        isMenuOpen={isMenuOpen}
        setIsMenuOpen={setIsMenuOpen}
        isDarkMode={isDarkMode}
        setIsDarkMode={setIsDarkMode}
        setActiveView={setActiveView}
        styles={styles}
      />
      
      {renderView()}
    </div>
  );
}

export default App;